import axios from 'axios'
import cfg from '../config/index'
import qs from 'qs'
import router from '../router'
import { Notify } from 'vant'
import { getToken, getRefreshToken, checkRefreshToken } from '../services/common'

const baseURL = cfg.baseApi
// const auth = '' // 暂时 todo
const auth = cfg.reqAuth // 暂时 todo
const whiteList = cfg.whiteList // array

const service = axios.create({
  baseURL: baseURL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000, // request timeout
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})
const CancelToken = axios.CancelToken
let requestList = []
const gloablData = {
  countRepeat: 0
}

console.log(gloablData)

const Message = options => {
  return Notify(options)
}

const tempStatusLoading = {
  state: false
}

const cancelAll = () => {
  requestList.forEach(c => {
    c.cancel()
  })
  requestList = []
}

// request interceptor
service.interceptors.request.use(
  async config => {
    const source = CancelToken.source()
    requestList.push(source)
    config.cancelToken = source.token
    config.requestCancelAll = cancelAll

    const token = await getToken()
    if (config.headerFormType === 'form') {
      config.headers = {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    } else {
      config.headers = {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }

    // todo  需要改进方法
    if (String(config.url).indexOf('/user/smslogin') > -1) {
      config.headers.Authorization = auth
    } else {
      token && (config.headers.Authorization = `bearer ${token}`)
    }

    // get传参 键值对解析
    if (config.data && config.method.toLocaleLowerCase() === 'get') {
      config.url += `?${qs.stringify(config.data)}`
    }

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(

  async response => {
    const headers = response.headers
    const res = response.data

    const ct = headers['content-type']
    if (ct.indexOf('application/x-www-form-urlencoded;charset=UTF-8') < 0 && ct.indexOf('application/json;charset=UTF-8') < 0) {
      return response
    }
    // console.log(res)
    // 如果状态码不为 0 并且存在message 字段
    if (res.status !== 0 && res.message) {
      if (res.status === 401 || res.status == 11002) {
        console.log('未授权')
        cancelAll()
        // todo
        localStorage.setItem('token_key', '')

        const countRepeat = parseInt(localStorage.getItem('countRepeat')) || 0 // 登录异常 直接抛出
        if (countRepeat > 1) {
          localStorage.setItem('countRepeat', '0')
          localStorage.setItem('token_buffer', '')
          router.push('/login')
          return response
        }

        localStorage.setItem('countRepeat', String(countRepeat + 1))

        if (!whiteList.filter(o => o === router.currentRoute.path).length) {
          const refreshToken = await getRefreshToken()
          if (!refreshToken) {
            router.push('/login')
            // console.log(router.currentRoute, 'router.currentRoute')
          } else {
            checkRefreshToken(refreshToken, tempStatusLoading)
          }
        }
      } else {
        Message({
          message: res.details || 'Error',
          type: 'warning',
          duration: 2 * 1000
        })
      }
      // return Promise.reject(new Error(res.message || 'Error'))
      return response
    } else {
      localStorage.setItem('countRepeat', '0') // 重置计时
      return response
    }
  },
  error => {
    if (error && error.message) {
      // let RegExE = /timeout of [0-9]+ms exceeded/;
      let message = error.message
      error.message.includes('timeout') && (message = '请求超时')
      Message({
        message: `${message}`,
        type: 'warning'
      })
      Promise.reject(error)
    }
  }
)

export default service
